export default __webpack_public_path__ + "static/media/GFIL.90392fb3.png";